import { useEffect, useMemo, useRef } from 'react'

import { getStateOptions } from '@/utils/states'

export const useStateOptions = (country?: string | null, current?: string | null) =>
  useMemo(() => getStateOptions(country, current), [country, current])

// Note: US states and Canadian provinces are different lists, so a country change must clear the state
export const useClearStateOnCountryChange = (
  country: string | null | undefined,
  clear: VoidFunction,
) => {
  const clearRef = useRef(clear)
  const previousCountry = useRef(country)

  useEffect(() => {
    clearRef.current = clear
  })

  // Note: skipped on mount, so opening an edit form does not wipe the saved state
  useEffect(() => {
    if (previousCountry.current === country) return

    previousCountry.current = country
    clearRef.current()
  }, [country])
}
